import { memo, useState } from 'react'

import { Authorization } from '@/widgets/Authorization'

import { SvgArrowDown } from '@/shared/lib/@deprecated/iport-icons/iconsA/SvgArrowDown'
import { Modal } from '@/shared/ui'

import cl from './auth-trigger.module.scss'

interface AuthTriggerProps {
	onSuccess: () => void
}

export const AuthTrigger = memo((props: AuthTriggerProps) => {
	const { onSuccess } = props

	const [isModalOpen, setIsModalOpen] = useState(false)

	const onOpen = () => setIsModalOpen(true)
	const onClose = () => setIsModalOpen(false)

	return (
		<>
			<div className={cl.animation}>
				<div className={cl.root} onClick={onOpen}>
					<p>Войдите, чтобы узнать персональную цену</p>
					<SvgArrowDown size={24} />
				</div>
			</div>
			<Modal fullScreenOnMobile isOpen={isModalOpen} onClose={onClose}>
				<Authorization onSuccess={onSuccess} />
			</Modal>
		</>
	)
})
